import React, { Component } from 'react';

import { web3Accounts, web3Enable } from '@polkadot/extension-dapp';

import Tuto from './Tuto';
import RmrkMintForm from './RmrkMintForm';
import RmrkMintNftForm from './RmrkMintNftForm';
import RmrkSendNftForm from './RmrkSendNftForm';
import CollectionGallery from './CollectionGallery';
import NftGallery from './NftGallery';

// Component hosting all RMRK forms and the account selector
class RmrkForms extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountAddress: '',
      options: <option value="" key="loading">Loading...</option>,
      visible: {
        collectionGallery: true,
        nftGallery: false,
        mint: false,
        mintNft: false,
        sendNft: false,
        sendValue: false
      }
    };


    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateSelectsFromAPI = this.updateSelectsFromAPI.bind(this);
    this.openMintNftForCollection = this.openMintNftForCollection.bind(this);
    this.openSendNftForNft = this.openSendNftForNft.bind(this);
    this.openNftGallery = this.openNftGallery.bind(this);
    this.changeVisibilities = this.changeVisibilities.bind(this);
    this.mintNftForm = React.createRef();
    this.sendNftForm = React.createRef();
    this.scrollPoint = React.createRef();
    this.collectionGallery = React.createRef();
    this.nftGallery = React.createRef();
  }

  componentDidMount() {
    this.prepareRmrkForms();
  }

  handleInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    }, () => {
      this.updateSelectsFromAPI();
      this.changeVisibilities({
        collectionGallery: true,
        nftGallery: false,
        mint: false,
        mintNft: false,
        sendNft: false,
        sendValue: false
      })
    });
  }


  componentDidUpdate() {
    // Triggers refresh after update
    this.updateSelectsFromAPI();
  }

  updateSelectsFromAPI() {
    // Refreshes NFTs and collections in forms
    this.collectionGallery.current.loadCollectionCards();
  }

  // Function to open MintNft form for a given collection
  openMintNftForCollection(collection) {
    this.mintNftForm.current.setState({
      collectionId: collection.id,
      collectionName: collection.name,
      collectionImageUrl: collection.image.replace('cloudflare-ipfs.com/ipfs', 'everdreamsoft.mypinata.cloud/ipfs'),
      maxSupply: collection.maxSupply,
      chain: process.env.REACT_APP_CHAIN_NAME,
    }, () => {
      this.mintNftForm.current.fillSnField();
      this.changeVisibilities({ collectionGallery: false, mintNft: true });
    });
  }

  // Function to open sendNft form for a given NFT
  openSendNftForNft(nft) {
    this.sendNftForm.current.setState({
      nftId: nft.contract + "-" + nft.token.sn,
      nftImageUrl: nft.asset.image.replace('cloudflare-ipfs.com/ipfs', 'everdreamsoft.mypinata.cloud/ipfs'),
      nftName: nft.asset.name,
      nftCollectionId: nft.collectionId,
      nftCollectionName: nft.collectionName,
      chain: process.env.REACT_APP_CHAIN_NAME,
    }, () => {
      this.changeVisibilities({ nftGallery: false, sendNft: true });
    });
  }

  // Function to open NFT gallery
  openNftGallery() {
    this.nftGallery.current.loadNftCards();
    this.changeVisibilities({ collectionGallery: false, nftGallery: true });
  }

  // Function to change component visibilities, passed to children components
  changeVisibilities(newVisibility) {
    this.setState({
      visible: {
        collectionGallery: typeof newVisibility.collectionGallery !== "undefined" ? newVisibility.collectionGallery : this.state.visible.collectionGallery,
        nftGallery: typeof newVisibility.nftGallery !== "undefined" ? newVisibility.nftGallery : this.state.visible.nftGallery,
        mint: typeof newVisibility.mint !== "undefined" ? newVisibility.mint : this.state.visible.mint,
        mintNft: typeof newVisibility.mintNft !== "undefined" ? newVisibility.mintNft : this.state.visible.mintNft,
        sendNft: typeof newVisibility.sendNft !== "undefined" ? newVisibility.sendNft : this.state.visible.sendNft,
        sendValue: typeof newVisibility.sendValue !== "undefined" ? newVisibility.sendValue : this.state.visible.sendValue,
      }
    }, () => { this.scrollPoint.current.scrollIntoView({ behavior: 'auto' }); });
  }

  async prepareRmrkForms() {

    // Array of options in address select
    var options = Array();

    // Enable Web3 (mandatory)
    const extensions = await web3Enable(process.env.REACT_APP_WEB3_APPNAME);

    // Check if accounts found
    if (extensions.length === 0) {
      options[0] = <option value="" key="empty">No account found</option>;
      this.setState({ options: options });
    } else {
      // Get all accounts (formats : polka: 0 / kusama: 2 / westend (generic): 42)
      const allAccounts = await web3Accounts({ ss58Format: process.env.REACT_APP_SS58FORMAT_PREFIX });

      // Build account select
      var options = Array();
      for (var index in allAccounts) {
        options[index] =
          <option value={allAccounts[index].address} key={allAccounts[index].address}>
            {allAccounts[index].meta.name}: {allAccounts[index].address}
          </option>
      }

      this.setState({
        options: options,
        accountAddress: allAccounts[0].address // Selects first address
      });
    }
  }

  render() {
    return (
      <div className="vc_row wpb_row vc_row-fluid">

        <div className="card">
          <div className="card__content">
            <div className="col-12 form-group">
              <label>Selected {process.env.REACT_APP_CHAIN_NAME} account:</label>
              <select className="form-control" name="accountAddress" value={this.state.accountAddress} onChange={this.handleInputChange}>
                {this.state.options}
              </select>
            </div>
            <p className={this.state.accountAddress != '' ? 'd-none' : ''}>
              Please download <a target="_blank" href="https://polkadot.js.org/extension/">Polkadot.js extension</a> to use this app
            </p>
          </div>
        </div>

        <div ref={this.scrollPoint}></div>

        <CollectionGallery
          openMintNftForCollection={this.openMintNftForCollection}
          openNftGallery={this.openNftGallery}
          changeVisibilities={this.changeVisibilities}
          display={this.state.visible.collectionGallery}
          updateSelectsFromAPI={this.updateSelectsFromAPI}
          ref={this.collectionGallery}
          accountAddress={this.state.accountAddress}
          onChange={this.handleInputChange}
        />

        <NftGallery
          openSendNftForNft={this.openSendNftForNft}
          changeVisibilities={this.changeVisibilities}
          display={this.state.visible.nftGallery}
          ref={this.nftGallery}
          accountAddress={this.state.accountAddress}
          onChange={this.handleInputChange}
        />

        <RmrkMintForm
          changeVisibilities={this.changeVisibilities}
          display={this.state.visible.mint}
          updateSelectsFromAPI={this.updateSelectsFromAPI}
          accountAddress={this.state.accountAddress}
          onChange={this.handleInputChange}
        />

        <RmrkMintNftForm
          changeVisibilities={this.changeVisibilities}
          display={this.state.visible.mintNft}
          updateSelectsFromAPI={this.updateSelectsFromAPI}
          ref={this.mintNftForm}
          accountAddress={this.state.accountAddress}
          onChange={this.handleInputChange}
        />

        <RmrkSendNftForm
          changeVisibilities={this.changeVisibilities}
          display={this.state.visible.sendNft}
          updateSelectsFromAPI={this.updateSelectsFromAPI}
          ref={this.sendNftForm}
          accountAddress={this.state.accountAddress}
          onChange={this.handleInputChange}
        />

      </div>
    )

  }
}

export default RmrkForms;